/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { extractionTypeSchema } from './enums';

export const aiExtractionItemSchema = z.object({
  content: z.string().min(1),
  type: extractionTypeSchema,
  entryIndices: z.array(z.number().int().nonnegative()),
});

export type IAiExtractionItem = z.infer<typeof aiExtractionItemSchema>;

export const aiExtractionResponseSchema = z.object({
  items: z.array(aiExtractionItemSchema),
});

export type IAiExtractionResponse = z.infer<typeof aiExtractionResponseSchema>;
